export default __webpack_public_path__ + "static/media/app-store-soon.110350f6.svg";